module.exports = __webpack_public_path__ + "static/media/BoxPlotMCQ2_4.d2c7df36.svg";